/// <reference path="../types/index.d.ts" />

import '../client_forms/boldamerican4/style.css';
import FormStructure from './boldamerican4/form_structure';

export default FormStructure;